"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutateReviewDataFailedSchema = exports.MutateReviewDataSuccessSchema = void 0;
var zod_1 = require("zod");
var upload_photo_1 = require("../../../upload-photo");
exports.MutateReviewDataSuccessSchema = zod_1.z.object({
    /** 제출 결과 */
    result: zod_1.z.literal('SUCCESS'),
});
exports.MutateReviewDataFailedSchema = zod_1.z.object({
    /** 제출 결과 */
    result: zod_1.z.literal('FAILED'),
    /** 업로드 사진 정보 */
    photos: zod_1.z.array(upload_photo_1.UploadPhotoSchema),
});
